<template >
    <div class="height-100">
        <ul class="nav nav-tabs space-15 mobile-m-bottom-0 border-none" id="ActivityTab">
            <li :class="{ active: activeTab === 'history' }" class="m-left-10" v-if="credentials.bookingHistory">
                <a class="history-tab" href="#tabs-history" @click.prevent="setActiveTab('history')">History </a>
            </li>
            <li :class="{ active: activeTab === 'job-requests' }" class="m-left-10 mobile-m-top-5" v-if="credentials.bookingHistory">
              <a class="job-request-tab" href="#tabs-job-requests" @click.prevent="setActiveTab('job-requests')">Job Requests </a>
            </li>
          <li :class="{ active: activeTab === 'confirmation' }" class="m-left-10" v-if="credentials.bookingReminderAdd">
            <a class="confirmation-tab" href="#tabs-confirmation" @click.prevent="setActiveTab('confirmation')">Jop Confirmation</a>
          </li>

        </ul>

        <div class="tab-content">

            <div id="tabs-confirmation" v-if="credentials.bookingReminderAdd" :class="{'tab-pane no-padding height-100':true, 'active': activeTab === 'confirmation'}">
                    <confirmation-tab :item-id="itemId" :item-type="itemType" :credentials="credentials" :customer-id="customerId"></confirmation-tab>
            </div>


            <div id="attachments-data" v-if="credentials.attachment" :class="{'tab-pane no-padding height-100':true, 'active': activeTab === 'attachments'}">

            </div>
            <div id="tabs-job-requests" v-if="credentials.bookingHistory" :class="{'tab-pane no-padding height-100':true, 'active': activeTab === 'job-requests'}">
              <JobRequestsTab :item-id="itemId" :item-type="itemType"></JobRequestsTab>
            </div>
            <div id="tabs-history" v-if="credentials.bookingHistory" :class="{'tab-pane no-padding height-100':true, 'active': activeTab === 'history'}">
              <history-tab :item-id="bookingId??itemId" :item-type="itemType"></history-tab>
            </div>

        </div>

    </div>
</template>

<script>

import ConfirmationTab from "@/modules/Booking/components/BookingViewTabs/Activity/ConfirmationTab.vue";
import JobRequestsTab from "./JobRequestsTab.vue";

export default {
    name: "ActivityTabs",
    components: {JobRequestsTab, ConfirmationTab},
    props:{
        itemType: {
            type: String,
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        bookingId: {
          type: Number
        },
        credentials: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        },
        customerId:{
            type: Number,
            required: true
        }
    },
    data(){
      return {
          activeTab: 'confirmation',
      }
    },
    methods:{
        setActiveTab(tab) {
            this.activeTab = tab;
        },
    }
}
</script>

<style scoped>
.height-100{height: 100vw}

.border-none{
  border: none;
}
.nav-tabs .confirmation-tab{
  background-color: rgba(133, 182, 255, 1) !important;
  border-color: rgba(133, 182, 255, 1) !important;
  border-radius: 100px;
  color: rgb(46, 64, 81) !important;
  font-size: 14px;
}
.nav-tabs .job-request-tab{
  background-color: #37BD5D !important;
  border-color: #37BD5D !important;
  border-radius: 100px;
  color: rgb(46, 64, 81) !important;
  font-size: 14px;
}
.nav-tabs .history-tab{
  background-color: rgba(234, 236, 238, 1) !important;
  border-color: rgba(234, 236, 238, 1) !important;
  border-radius: 100px;
  color: rgb(46, 64, 81) !important;
  font-size: 14px;
}

@media screen and (max-width: 991px){
  .mobile-m-top-5 {
    margin-top: 5px;
  }
}
</style>
